import React from "react";
import "./style.scss";
import Icon from "../../elements/icon";
import Link from "../../elements/link";
import useQuery from "../../utils/useQuery";
import { appendQuery } from "../../utils/urlHelper";
import { generateReactKey } from "../../utils/reactKey";

const PersonalInformationAccordion = ({ fields, shippingDetails, billingDetails }) => {
  const query = useQuery();
  const { personalEditLink, shippingInfoTitle, billingAddressTitle } = fields;
  const link = personalEditLink && {
    ...personalEditLink.value,
    url: appendQuery(personalEditLink?.value?.href, query)
  };

  return (
    <div className="personal-details">
      <>
        <div className="personal-content-header">
          <div className="header">{shippingInfoTitle.value}</div>
          <div className="icon">
            {link && (
              <Link {...link}>
                <Icon name="Edit" className="edit-icon" colorScheme="outline-green" />
              </Link>
            )}
          </div>
        </div>
        <div className="personal-shipping">
          {(shippingDetails || []).map(row => (
            <div className="location-name" key={generateReactKey()}>
              {row}
            </div>
          ))}
        </div>

        <div className="personal-content-header">
          <div className="header">{billingAddressTitle.value}</div>
          <div className="icon">
            {link && (
              <Link {...link}>
                <Icon name="Edit" className="edit-icon" colorScheme="outline-green" />
              </Link>
            )}
          </div>
        </div>
        <div className="billing-address">
          {(billingDetails || []).map((row, index) => (
            <div className="location-name" key={generateReactKey()}>
              {row}
            </div>
          ))}
        </div>
      </>
    </div>
  );
};

export default PersonalInformationAccordion;
